module.exports = __webpack_public_path__ + "media/images/how_it_works_3-8d841ff629b82681dd4ddbd1acede0c2.png";